import { useCallback } from 'react';

import {
  KommoLeadEventListQuery,
  useKommoLeadEventListQuery,
} from 'core/graphql';

import { useLeadPermissions } from './useLeadPermissions';

/** ТЗ 0084 — журнал карточки лида. */

export type ILeadEvent = KommoLeadEventListQuery['kommoLeadEvents'][number];

const EMPTY_EVENTS: ILeadEvent[] = [];

/** Журнал карточки: SMS ушла / не ушла, примечание не записалось. */
export const useKommoLeadEvents = (leadId: string | null, enabled = true) => {
  const { canUse } = useLeadPermissions();
  const { data, loading, error, refetch } = useKommoLeadEventListQuery({
    variables: { leadId: leadId || '' },
    skip: !canUse || !enabled || !leadId,
    fetchPolicy: 'cache-and-network',
  });
  const reload = useCallback(() => {
    refetch()?.catch(() => undefined);
  }, [refetch]);
  return {
    events: data?.kommoLeadEvents ?? EMPTY_EVENTS,
    loading: loading && !data,
    failed: Boolean(error) && !data,
    reload,
  };
};
